module.exports = __webpack_public_path__ + "img/icon-divider2.11ac5e68.svg";